import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom';
import { Helmet } from "react-helmet";
import CustomNavbar from '../../../customNavbar';
import styles from './viewQuizTemplate.module.scss';
import { Accordion, Card, Col, Row, Button, Alert } from 'react-bootstrap';
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import { CustomButton } from '../../../../shared/customButton';
import CreateQuestionModal from './createQuestionModal';
import EditQuestionModal from './editQuestionModal';
import { activateQuizTemplate, deleteQuestionFromQuiz, disableQuizTemplate, getQuizTemplate, putBackToDraft, copyTemplateToNew, checkIfTemplateEligibleToDisableOrPutBackToDraft, changeQuestionOrder } from '../../../../../services/util/quizTemplates';
import CSSLoader from '../../../../shared/cssLoader';
import ReactTooltip from 'react-tooltip';
import EditQuizTemplate from './editQuizTemplateModal';
import { CustomConfirmationModal } from '../../../../shared/customConfirmationModal';
import { CustomMessagePopUpBox } from '../../../../shared/customMessagePopUpBox';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const ViewQuizTemplates = (props) => {

    let [isURLLoading, setURLLoading] = useState(false);
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [getDataIsLoading, getDataSetLoading] = useState(false);
    const [showAddQuestionModal, setShowAddQuestionModal] = useState(false);
    const [showEditQuestionModal, setShowEditQuestionModal] = useState(false);
    const [showEditQuizTemplateModal, setShowEditQuizTemplateModal] = useState(false);
    let [quizTemplateData, setQuizTemplateData] = useState();
    let [editQuestionData, setEditQuestionData] = useState();

    let [showActivateTemplatePopup, setShowActivateTemplatePopup] = useState(false);
    let [showDisablePopup, setShowDisablePopup] = useState(false);
    let [showBackToDraftPopup, setShowBackToDraftPopup] = useState(false);
    let [showCopyToNewPopup, setShowCopyToNewPopup] = useState(false);

    let [showNotEligibleForDisablePopup, setNotEligibleForDisablePopup] = useState(false);
    let [showNotEligibleForDraftPopup, setNotEligibleForDraftPopup] = useState(false);
    let [attachedPipelines, setAttachedPipelines] = useState('');


    let [showQuesDeletePopup, setShowQuesDeletePopup] = useState(false);

    let [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);
    let [disableButtonLoading, setDisableButtonLoading] = useState(false);
    let [putBackToDraftButtonLoading, setPutBackToDraftButtonLoading] = useState(false);

    let [questionCount, setQuestionCount] = useState();
    let [question_id, setQuestionid] = useState();
    let { id } = useParams();


    const history = useHistory();
    const breadcrumb = [
        {
            pathaddress: '/app/company/templates/quiz-templates',
            pathname: 'Quiz Templates',
            isActive: false,
            key: 3 + 'Quiz Templates'
        },
        {
            pathaddress: `/app/company/quiz-template/${id}`,
            pathname: quizTemplateData?.name,
            isActive: true,
            key: 2 + quizTemplateData?.name
        }
    ]

    const getQuizTemplateValues = async () => {
        getDataSetLoading(true);
        let response = await getQuizTemplate(id);
        if (response.success == true) {
            setQuizTemplateData(response.data);
            setQuestionCount(response.data.question_count);
            getDataSetLoading(false);
        }
        else {
            getDataSetLoading(true);
        }

    }

    const refreshData = () => {
        getQuizTemplateValues();
    }

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon)
    }

    // functions for handle all modals
    const handleClose = () => {
        setShowAddQuestionModal(false);
        setShowEditQuestionModal(false);
        setShowEditQuizTemplateModal(false);
        setShowActivateTemplatePopup(false);
        setShowCopyToNewPopup(false)
        setShowDisablePopup(false);
        setShowQuesDeletePopup(false);
        setShowBackToDraftPopup(false);
        setNotEligibleForDisablePopup(false);
        setNotEligibleForDraftPopup(false)
        setAttachedPipelines('');
    }
    const handleShow = () => setShowAddQuestionModal(true);
    const handleShowEdit = (values, ques_no) => {
        setShowEditQuestionModal(true);
        let editModalData = {
            rowValues: values,
            question_no: ques_no + 1,
            questionTemplateName: quizTemplateData?.name
        }
        setEditQuestionData(editModalData)
    }

    const handleShowActivatePopup = () => { setShowActivateTemplatePopup(true) }
    const handleShowCopyToNewPopup = () => { setShowCopyToNewPopup(true) }


    const handleShowEditQuizModal = () => { setShowEditQuizTemplateModal(true); }
    const handleShowDeleteQuestion = (values, index) => { setShowQuesDeletePopup(true); setQuestionid(values._id) }

    const activateTemplate = async () => {
        setModalActionButtonLoading(true)
        let response = await activateQuizTemplate(id);
        if (response.success == true) {
            getQuizTemplateValues();
            setModalActionButtonLoading(false)
            handleClose();
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const disableTemplate = async () => {
        setModalActionButtonLoading(true)
        let response = await disableQuizTemplate(id);
        if (response.success == true) {
            getQuizTemplateValues();
            setModalActionButtonLoading(false)
            handleClose();
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const deleteQuestionFromTemplate = async () => {
        setModalActionButtonLoading(true)
        let response = await deleteQuestionFromQuiz(id, question_id);
        if (response.success == true) {
            getQuizTemplateValues();
            setModalActionButtonLoading(false)
            handleClose();
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const putToDraftAgain = async () => {
        setModalActionButtonLoading(true)
        let response = await putBackToDraft(id);
        if (response.success == true) {
            getQuizTemplateValues();
            setModalActionButtonLoading(false)
            handleClose();
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const copyToNew = async () => {
        setModalActionButtonLoading(true)
        let response = await copyTemplateToNew(id);
        if (response.success == true) {
            history.push(`/app/company/templates/quiz-templates/${response.data.new_quiz_template_id}`);
            handleClose();
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const checkEligiblityToDisable = async () => {
        setDisableButtonLoading(true)
        let response = await checkIfTemplateEligibleToDisableOrPutBackToDraft(id);
        if (response.success == true) {

            if (response.data.is_eligible) {
                setShowDisablePopup(true);
            }
            else {
                let pipeline_name_string = ''
                for (let index = 0; index < (response.data.pipelines_array).length; index++) {
                    pipeline_name_string = '"' + response.data.pipelines_array[index].pipeline_name + '", ';
                }

                pipeline_name_string = pipeline_name_string.substring(0, pipeline_name_string.length - 2);
                setAttachedPipelines(pipeline_name_string);
                setNotEligibleForDisablePopup(true);
            }

            setDisableButtonLoading(false)
        } else {
            setDisableButtonLoading(false)
        }
    }

    const checkEligiblityToPutBackToDraft = async () => {
        setPutBackToDraftButtonLoading(true)
        let response = await checkIfTemplateEligibleToDisableOrPutBackToDraft(id);
        if (response.success == true) {

            if (response.data.is_eligible) {
                setShowBackToDraftPopup(true);
            }
            else {
                let pipeline_name_string = ''
                for (let index = 0; index < (response.data.pipelines_array).length; index++) {
                    pipeline_name_string = '"' + response.data.pipelines_array[index].pipeline_name + '", ';
                }

                pipeline_name_string = pipeline_name_string.substring(0, pipeline_name_string.length - 2);
                setAttachedPipelines(pipeline_name_string);
                setNotEligibleForDraftPopup(true);
            }

            setPutBackToDraftButtonLoading(false)
        } else {
            setPutBackToDraftButtonLoading(false)
        }
    }

    const handleOnDragEnd = async(result) => {
        if (!result.destination) {
            return;
        }
        const questionArray = Array.from(quizTemplateData.questions); 
        const [reorderedItem] = questionArray.splice(result.source.index, 1);
        questionArray.splice(result.destination.index, 0, reorderedItem);
        quizTemplateData.questions = [];
        setQuizTemplateData(prevData => ({...prevData, questions: questionArray}));
        await changeQuestionOrder(id,questionArray);
    };

    useEffect(() => {
        getQuizTemplateValues()
    }, [])

    return (
        <div>
            {/* modal for create question */}
            {
                showAddQuestionModal === true ?
                    <CreateQuestionModal showModal={showAddQuestionModal} handleClose={handleClose} refreshData={getQuizTemplateValues} id={id} quizTemplateData={quizTemplateData} />
                    : null
            }
            {/* modal for edit question */}
            {
                showEditQuestionModal === true ?
                    <EditQuestionModal showModal={showEditQuestionModal} handleClose={handleClose} refreshData={refreshData} id={id} data={editQuestionData} />
                    : null
            }
            {/* modal for edit quiz template */}
            {
                showEditQuizTemplateModal === true ?
                    <EditQuizTemplate showModal={showEditQuizTemplateModal} handleClose={handleClose} refreshData={refreshData} id={id} data={quizTemplateData} />
                    : null
            }
            <Helmet>
                <title>Quiz Template | HireTrace</title>
            </Helmet>

            {getDataIsLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :

                <div>
                    {/* activate template modal */}
                    <CustomConfirmationModal
                        show={showActivateTemplatePopup}
                        confirmationType='success'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={activateTemplate}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to activate the quiz. After activating, you can use this template in hiring pipeline steps to evaluate candidates`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, Activate!"
                    />
                    {/* not eligible to put template back to draft mode messsage modal */}
                    <CustomMessagePopUpBox
                        show={showNotEligibleForDraftPopup}
                        confirmationType='warning'
                        cancelIconclick={handleClose}
                        onPrimaryBtnClick={handleClose}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Cannot Put Back To Draft"
                        message={`You cannot put this template back to draft mode. Because the templates is attached with active piepelines (${attachedPipelines})`}
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="primaryBtn"
                        primaryBtnLabel="Ok"
                    />
                    {/* put quiz template back to draft modal */}
                    <CustomConfirmationModal
                        show={showBackToDraftPopup}
                        confirmationType='success'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={putToDraftAgain}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to put this question template back to draft mode`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Back To Draft!"
                    />

                    {/* copy quiz template to new modal */}
                    <CustomConfirmationModal
                        show={showCopyToNewPopup}
                        confirmationType='success'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={copyToNew}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to copy this template and create new? This will create a new quiz template with exact same details of this template`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Copy To New!"
                    />
                    {/* not eligible to disable template messsage modal */}
                    <CustomMessagePopUpBox
                        show={showNotEligibleForDisablePopup}
                        confirmationType='warning'
                        cancelIconclick={handleClose}
                        onPrimaryBtnClick={handleClose}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Cannot Disable"
                        message={`You cannot disable this template. Because the templates is attached with active piepelines (${attachedPipelines})`}
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="primaryBtn"
                        primaryBtnLabel="Ok"
                    />
                    {/* disable template modal */}
                    <CustomConfirmationModal
                        show={showDisablePopup}
                        confirmationType='danger'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={disableTemplate}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to disable the quiz template. After disabling you cannot edit or reactivate this template`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, Disable!"
                    />

                    {/* question delete modal */}
                    <CustomConfirmationModal
                        show={showQuesDeletePopup}
                        confirmationType='danger'
                        cancelIconclick={handleClose}
                        onSecondaryBtnClick={handleClose}
                        onPrimaryBtnClick={deleteQuestionFromTemplate}
                        isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                        primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage={`You want to delete this question ? This cannot be undone`}
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, Delete!"
                    />


                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                    <div className={styles.BodyContainer}>
                        <Row className={styles.bodyRow}>

                            {/* middle component */}
                            <Col md={8} lg={9} xl={10} >
                                <Col>
                                    <Accordion defaultActiveKey="0" className={styles.accordianMain}>
                                        <Card className={styles.accordianCard}>
                                            <Accordion.Toggle as={Card.Header} eventKey="0" className={styles.cardHeader} onClick={() => changeAccordionIcon()}>
                                                <div className={styles.headerDetails}>
                                                    <p className={styles.accordianHeaderTopic}>COMMON DETAILS</p>
                                                    <div >
                                                        {/* edit option available on draft mode only */}
                                                        {quizTemplateData?.state == 0 && <Button variant="warning" type="submit" className={styles.actionButtons}
                                                            onClick={() => handleShowEditQuizModal()}
                                                        // disabled={(props.permissions.actions.delete_pipeline === false && props.role === 1) ? true : false}
                                                        >
                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </Button>}
                                                    </div>
                                                    <div className={styles.plusMinusDiv}>

                                                        {accordionIcon === true ?
                                                            (
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M18 15L12 9L6 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>

                                                            )
                                                            :
                                                            (
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M6 8.99902L12 14.999L18 8.99902" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>

                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="0">
                                                <Card.Body >
                                                    <Row>
                                                        <Col className="text-left">
                                                            <Row>
                                                                <Col lg={5}>
                                                                    <p className={styles.headerTopic}>Quiz Name</p>
                                                                </Col>
                                                                <Col className="text-left" id={styles.quizNameStyle} >
                                                                    <p className={styles.headerValue}>{quizTemplateData?.name}</p><span>{quizTemplateData?.state === 10 ? <Alert variant="success" className={styles.badgeType}>Active</Alert> : quizTemplateData?.state === 0 ? <Alert variant="warning" className={styles.badgeTypeWarning}>Draft</Alert> : quizTemplateData?.state === -10 ? <Alert variant="danger" className={styles.badgeTypeDanger}>Disabled</Alert> : null}</span>
                                                                </Col>

                                                            </Row>
                                                        </Col>
                                                        <Col className="text-left">
                                                            <Row>
                                                                <Col lg={5}>
                                                                    <p className={styles.headerTopic}>Time Period</p>
                                                                </Col>
                                                                <Col className="text-left">
                                                                    <p className={styles.headerValue}>{quizTemplateData?.duration} mins</p>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <hr className={styles.dividerLine} />
                                                    <Row>
                                                        <Col className="text-left">
                                                            <Row>
                                                                <Col lg={5}>
                                                                    <p className={styles.headerTopic}>Quiz Specialization</p>
                                                                </Col>
                                                                <Col className="text-left">
                                                                    <p className={styles.headerValue}>{quizTemplateData?.specialization}</p>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col lg={6} className="text-left">
                                                            <Row>
                                                                <Col lg={5}>
                                                                    <p className={styles.headerTopic}>Study Areas</p>
                                                                </Col>
                                                                <Col lg={7} className="text-left">
                                                                    {quizTemplateData?.subject_areas.map((value, index) => (
                                                                        <span className={styles.studyAreaArray} key={index}>{value}
                                                                            {index != quizTemplateData?.subject_areas.length - 1 &&
                                                                                <>,</>
                                                                            }

                                                                        </span>
                                                                    ))
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    <hr className={styles.dividerLine} />
                                                    <Row>
                                                        <Col>
                                                            <p className={styles.headerTopic}>Quiz Description</p>
                                                            {quizTemplateData?.description ?
                                                                <p className={styles.headerValueSecondary}>{quizTemplateData?.description}</p>
                                                                :
                                                                <p className={styles.headerValueSecondary}> No Decription to display</p>
                                                            }

                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                    <h4 className={styles.evalStepsTitle}>Questions</h4>
                                    {quizTemplateData?.questions.length !== 0 ?

                                        <div>
                                            <DragDropContext  onDragEnd={handleOnDragEnd}>
                                                <Droppable droppableId="quizTemplateData">
                                                    {(provided) => (
                                                        <>
                                                            <div ref={provided.innerRef} {...provided.droppableProps}>

                                                                {quizTemplateData?.questions.length !== 0 &&
                                                                    quizTemplateData?.questions.map((Value, index) => (
                                                                        <Draggable key={index} draggableId={`quizTemplateData-${index}`} index={index} isDragDisabled={quizTemplateData?.state == 10}>
                                                                            {(provided) => (

                                                                                <Accordion className={styles.accordianMain} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                    <Card className={styles.accordianCard}>
                                                                                        <Accordion.Toggle as={Card.Header} eventKey="0" className={styles.cardQuestionHeader} onClick={() => changeAccordionIcon()}>


                                                                                            <div className={styles.pipelineStepsCardHeaderDiv}>
                                                                                                <p className={styles.QuestionCardHeaderText}>Question {index + 1} &nbsp;-&nbsp;<span className={styles.pipelineStepsCardHeaderTextValue}>{Value.question.substring(0, 60)}</span></p>

                                                                                                <div >
                                                                                                    {/* Edit and delete question options available on draft mode only */}
                                                                                                    {quizTemplateData?.state == 0 && <>
                                                                                                        <Button variant="warning" type="submit" className={styles.actionButtons}
                                                                                                            onClick={() => handleShowEdit(Value, index)}
                                                                                                        // disabled={(props.permissions.actions.delete_pipeline === false && props.role === 1) ? true : false}
                                                                                                        >
                                                                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                                <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                            </svg>

                                                                                                        </Button>

                                                                                                        <Button variant="warning" type="submit" className={styles.actionButtons}
                                                                                                            onClick={() => handleShowDeleteQuestion(Value, index)}
                                                                                                        // disabled={(props.permissions.actions.delete_pipeline === false && props.role === 1) ? true : false}
                                                                                                        >
                                                                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M3 6H21" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                                <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                                <path d="M10 11V17" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                                <path d="M14 11V17" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                            </svg>

                                                                                                        </Button>
                                                                                                    </>

                                                                                                    }

                                                                                                </div>
                                                                                                <div className={styles.plusMinusDiv}>

                                                                                                    {accordionIcon === true ?
                                                                                                        (
                                                                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M18 15L12 9L6 15" stroke="#2DA6C0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                            </svg>

                                                                                                        )
                                                                                                        :
                                                                                                        (
                                                                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M6 8.99902L12 14.999L18 8.99902" stroke="#2DA6C0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                                                            </svg>

                                                                                                        )
                                                                                                    }

                                                                                                </div>
                                                                                            </div>
                                                                                        </Accordion.Toggle>
                                                                                        <Accordion.Collapse eventKey="0">
                                                                                            <Card.Body >
                                                                                                <div>
                                                                                                    <div >
                                                                                                        <div className='ml-3'>
                                                                                                            <Row>
                                                                                                                <Col lg={0.5}>
                                                                                                                    <Card.Title className={styles.headerTopic}>Q{index + 1}</Card.Title>

                                                                                                                </Col>
                                                                                                                <Col>
                                                                                                                    <Card.Title className={styles.headerTopic}>{Value.question}?</Card.Title>
                                                                                                                </Col>
                                                                                                                <Col lg={2}>
                                                                                                                    {
                                                                                                                        Value.is_multiple_answer_question ? <Alert variant="warning" className={styles.badgeTypeWarning}>Multiple Answers</Alert>
                                                                                                                            :
                                                                                                                            <Alert variant="warning" className={styles.badgeTypeWarning}>Single Answer</Alert>
                                                                                                                    }
                                                                                                                </Col>
                                                                                                            </Row>
                                                                                                        </div>

                                                                                                        <div className={styles.rowValues}>
                                                                                                            <div>
                                                                                                                {Value.answers.map((value, index) => (

                                                                                                                    <Row className={value.is_correct ? styles.correctAnswer : null}>

                                                                                                                        <Col lg={0.5}>
                                                                                                                            <p className="mb-1" key={index}><i className="fas fa-circle"></i></p>
                                                                                                                        </Col>
                                                                                                                        <Col>
                                                                                                                            {value.answer}
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                    // <p className="mb-1" key={index}><i className="fas fa-circle"></i>&nbsp;{value.answer}</p>
                                                                                                                ))
                                                                                                                }
                                                                                                            </div>




                                                                                                        </div>


                                                                                                    </div>

                                                                                                </div>
                                                                                            </Card.Body>
                                                                                        </Accordion.Collapse>
                                                                                    </Card>
                                                                                </Accordion>
                                                                            )}
                                                                        </Draggable>
                                                                    ))

                                                                }
                                                                {provided.placeholder}
                                                            </div>
                                                        </>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                            {quizTemplateData?.state == 0 &&
                                                <div className='mt-4'>
                                                    <CustomButton
                                                        buttonType="button"
                                                        label="Add New Question"
                                                        type="primaryBtn"
                                                        handleClick={handleShow}
                                                        // disabled={(props.permissions.actions.edit_quiz_templates === true || props.role === 0) ? false : true}
                                                        // toolTipId={props.permissions.actions.edit_quiz_templates === false && props.role === 1 && "permissionError"}
                                                        // toolTip={props.permissions.actions.edit_quiz_templates === false && props.role === 1 && "Permission Denied"}
                                                        // showToolTip={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? true : false}
                                                    />
                                                </div>
                                            }


                                        </div>
                                        :
                                        <Col className='mt-4'>
                                            {quizTemplateData?.state == 0 && <>
                                                <p className={styles.noEvalStagesMsg}> You haven't added any Questions yet.</p>
                                                <div>
                                                    <CustomButton
                                                        buttonType="button"
                                                        label="Add New Question"
                                                        type="primaryBtn"
                                                        handleClick={handleShow}
                                                        // disabled={(props.permissions.actions.edit_quiz_templates === true || props.role === 0) ? false : true}
                                                        // toolTipId={props.permissions.actions.edit_quiz_templates === false && props.role === 1 && "permissionError"}
                                                        // toolTip={props.permissions.actions.edit_quiz_templates === false && props.role === 1 && "Permission Denied"}
                                                        // showToolTip={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? true : false}
                                                    />
                                                </div>
                                            </>
                                            }
                                        </Col>


                                    }
                                </Col>



                            </Col>

                            {/* side bar */}
                            <Col>

                                {quizTemplateData?.state == 0 &&

                                    <div className='mb-3'>
                                        <CustomButton
                                            buttonType="button"
                                            label="Activate"
                                            type="secondaryBtn"
                                            handleClick={handleShowActivatePopup}
                                            disabled={(questionCount === 0) ? true : false}
                                            toolTipId={questionCount === 0 ? "AddQuestionsFirstError" : null}
                                            toolTip={questionCount === 0 ? "Add questions before activating" : null}
                                            showToolTip={(questionCount === 0) ? true : false}
                                            // frontIcon={
                                            //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            //         <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            //         <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            //     </svg>

                                            // }
                                            // disabled={((props.permissions.actions.edit_quiz_templates === false && props.role === 1) || (questionCount === 0)) ? true : false}
                                            // toolTipId={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? "activateQuizTemplatePermissionError" : questionCount === 0 ? "AddQuestionsFirstError" : null}
                                            // toolTip={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? "Permission Denied" : questionCount === 0 ? "Add questions before activating" : null}
                                            // showToolTip={((props.permissions.actions.edit_quiz_templates === false && props.role === 1) || (questionCount === 0)) ? true : false}

                                        />
                                    </div>
                                }

                                {quizTemplateData?.state == 10 &&
                                    <div className='mb-3'>

                                        <CustomButton
                                            buttonType="button"
                                            label="Back To Draft"
                                            type="dangerBtn"
                                            handleClick={checkEligiblityToPutBackToDraft}
                                            backicon={putBackToDraftButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                                            // frontIcon={
                                            //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">\
                                            //         <polyline points="3 6 5 6 21 6"></polyline>
                                            //         <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                            //         <line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                                            //     </svg>
                                            // }
                                            // disabled={
                                            //     ((props.permissions.actions.edit_quiz_templates === false && props.role === 1) || putBackToDraftButtonLoading) ? true : false
                                            // }
                                            // toolTipId={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? "backToDraftQuiztemplatePermissionError" : null}
                                            // toolTip={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? "Permission Denied" : null}
                                            // showToolTip={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? true : false}

                                        />
                                    </div>
                                }

                                {(quizTemplateData?.state == 10 || quizTemplateData?.state == 0 || quizTemplateData?.state == -10) &&
                                    <div className='mb-3'>

                                        <CustomButton
                                            buttonType="button"
                                            label="Copy to New"
                                            type="defaultBtn"
                                            handleClick={handleShowCopyToNewPopup}
                                            // frontIcon={
                                            //     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">\
                                            //         <polyline points="3 6 5 6 21 6"></polyline>
                                            //         <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                            //         <line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                                            //     </svg>
                                            // }
                                            // disabled={
                                            //     props.permissions.actions.edit_quiz_templates === false && props.role === 1 ? true : false
                                            // }
                                            // toolTipId={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? "copyToNewQuiztemplatePermissionError" : null}
                                            // toolTip={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? "Permission Denied" : null}
                                            // showToolTip={(props.permissions.actions.edit_quiz_templates === false && props.role === 1) ? true : false}

                                        />
                                    </div>
                                }

                                {(quizTemplateData?.state == 10 || quizTemplateData?.state == 0) &&

                                    <div className='mb-3'>
                                        <CustomButton
                                            buttonType="button"
                                            label="Disable"
                                            type="defaultBtn"
                                            handleClick={checkEligiblityToDisable}
                                            backicon={disableButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                                            // frontIcon={
                                            //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            //         <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            //         <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            //     </svg>

                                            // }
                                            // disabled={
                                            //     ((props.permissions.actions.delete_quiz_templates === false && props.role === 1) || disableButtonLoading) ? true : false
                                            // }
                                            // toolTipId={props.permissions.actions.delete_quiz_templates === false && props.role === 1 && "disableQuizTemplatePermissionError"}
                                            // toolTip={props.permissions.actions.delete_quiz_templates === false && props.role === 1 && "Permission Denied"}
                                            // showToolTip={props.permissions.actions.delete_quiz_templates === false && props.role === 1 ? true : false}

                                        />

                                    </div>
                                }

                            </Col>
                        </Row >

                    </div >
                </div >
            }
        </div >
    )
}

export default ViewQuizTemplates;
